import { TabsProps } from 'antd';

export const tabs: TabsProps['items'] = [
    {
        label: 'Пользователи',
        key: 'users',
    },
    {
        label: 'Сообщества',
        key: 'communities',
    },
    {
        label: 'Платежи',
        key: 'payments',
    },
    {
        label: 'Обратная связь',
        key: 'feedback',
    },
    {
        label: 'Настройка магазинов',
        key: 'shop-details',
    },
];
